// Tour step definitions. Steps with simulated/fabricated flags render their own full-screen overlays
// instead of the standard tooltip. Steps with an anchor use the DOM-measurement tooltip engine.
export const TOUR_STEPS = [
  {
    id: 'seeds',
    page: 'seeds',
    anchor: 'tour-seeds-browse-catalog',
    copy: 'Browse hundreds of plants, or add your own. Every detail — start dates, spacing, water needs — is yours to set, and we\'ll use it to plan your season.',
    stub: false,
  },
  {
    id: 'layout',
    page: 'layout',
    anchor: null, // SimulatedLayoutStop renders its own overlay — no real DOM anchor needed
    copy: 'Build your layout, then track each stage of your plantings along the way.',
    simulated: true,
  },
  {
    id: 'plantings',
    page: 'plantings',
    anchor: null, // FabricatedPlantingsStop renders its own overlay — no real DOM anchor needed
    copy: 'Tap any stage as it happens — Started, Germinated, Transplanted.',
    fabricated: true,
  },
  {
    id: 'tasks',
    page: 'tasks',
    anchor: 'tour-tasks-add-button',
    copy: 'Add a task for any plant or bed. We\'ll remind you when it\'s time.',
    stub: false,
  },
  {
    id: 'harvests',
    page: 'harvests',
    anchor: 'tour-harvests-add-button',
    copy: 'Log your harvests by weight to see how much your garden is producing, and which plants are leading the way.',
    stub: false,
  },
];

// Map page id → URL path
export const PAGE_PATHS = {
  seeds: '/seeds',
  layout: '/layout',
  plantings: '/plantings',
  tasks: '/tasks',
  harvests: '/harvests',
  dashboard: '/',
};
